<div class="tag-container" *ngIf="tags">
  <div class="patient-tag"  *ngFor="let t of tags">
    <div [ngClass]="getTagClass(t)">{{toInitCase(t.text)}}</div> 
  </div>
</div>